import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { toProductPath } from "../utils/slugify";

function ProductCard({ product, addToCart }) {
  const navigate = useNavigate();
  const [tilt, setTilt] = useState({ x: 0, y: 0 });
  const [hov, setHov] = useState(false);
  const [done, setDone] = useState(false);

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width;
    const y = (e.clientY - r.top) / r.height;
    setTilt({ x: (y - 0.5) * 7, y: (x - 0.5) * -7 });
  };
  const onLeave = () => { setTilt({ x: 0, y: 0 }); setHov(false); };

  const handleAdd = () => {
    addToCart(product);
    setDone(true);
    setTimeout(() => setDone(false), 1600);
  };

  return (
    <div
      className="pc3"
      onMouseMove={onMove}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={onLeave}
    >
      <div
        className="pc3-inner"
        style={{
          transform: `perspective(1100px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg) translateZ(${hov ? 5 : 0}px)`,
          transition: hov
            ? "transform 0.1s ease"
            : "transform 0.7s cubic-bezier(.23,1,.32,1), box-shadow 0.4s ease",
        }}
      >
        {/* Image */}
        <div className="pc3-img-wrap">
          {product.imageUrl ? (
            <img className="pc3-img" src={product.imageUrl} alt={product.name} />
          ) : (
            <div className="pc3-no-img">NO IMAGE</div>
          )}
          <div className="pc3-img-ov">
            <span className="pc3-img-ov-txt">Quick View</span>
          </div>
          <div className="pc3-badge">New</div>
        </div>

        {/* Body */}
        <div className="pc3-body">
          <h3 className="pc3-name" onClick={() => navigate(toProductPath(product.id, product.name))}>{product.name}</h3>
          <p className="pc3-desc">{product.description}</p>

          {/* Rating */}
          <div className="pc3-stars">
            {[...Array(5)].map((_, i) => (
              <svg key={i} width="11" height="11" viewBox="0 0 24 24"
                fill={i < 4 ? "#10b981" : "none"} stroke="#10b981" strokeWidth="1.8">
                <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
              </svg>
            ))}
            <span className="pc3-stars-lbl">(4.0)</span>
          </div>

          <div className="pc3-footer">
            <div className="pc3-price-block">
              {product.salePrice != null ? (
                <>
                  <div className="pc3-price-top">
                    <span className="pc3-price-was">₹{product.price}</span>
                    {product.salePercent != null && (
                      <span className="pc3-sale-badge">{product.salePercent}% OFF</span>
                    )}
                  </div>
                  <span className="pc3-price pc3-price-sale">₹{product.salePrice}</span>
                </>
              ) : product.mrp != null && product.mrp > product.price ? (
                <>
                  <span className="pc3-mrp">₹{product.mrp}</span>
                  <span className="pc3-price">₹{product.price}</span>
                </>
              ) : (
                <span className="pc3-price">₹{product.price}</span>
              )}
            </div>
            <div className="pc3-btns">
              <button className="pc3-view" onClick={() => navigate(toProductPath(product.id, product.name))}>
                View
              </button>
              <button className={`pc3-add${done ? " done" : ""}`} onClick={handleAdd}>
                {done ? "Added ✓" : "Add"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
